// extracted by mini-css-extract-plugin
module.exports = {"firstData":"suggestionCard_firstData__2HjJx","secondData":"suggestionCard_secondData__2S8me"};